var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUVaultLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1029,
    height: 225,
    viewBox: "0 0 1029 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.165 48.6267L389.092 220.075H338.744L273.671 48.6267H322.307L363.75 168.641L405.534 48.6267H454.169H454.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.326 48.6267V220.075H590.145V199.845C577.817 215.274 559.323 224.875 534.317 224.875C488.765 224.875 451.09 185.443 451.09 134.351C451.09 83.2582 488.765 43.8262 534.317 43.8262C559.318 43.8262 577.813 53.4273 590.145 68.8564V48.6267H634.326ZM590.145 134.351C590.145 105.547 569.939 86.004 542.54 86.004C515.142 86.004 495.276 105.547 495.276 134.351C495.276 163.154 515.482 182.697 542.54 182.697C569.599 182.697 590.145 163.154 590.145 134.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.053 48.6267V220.075H778.872V200.872C768.596 216.301 750.787 224.875 727.838 224.875C691.535 224.875 663.106 199.499 663.106 153.894V48.6267H707.287V148.407C707.287 171.723 721.332 183.725 741.197 183.725C762.775 183.725 778.872 171.037 778.872 141.206V48.6267H823.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.915 0.616211H899.096V220.074H854.915V0.616211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.614 48.6272H0.600098V144.961C0.600098 189.986 31.9194 220.075 78.9629 220.075C126.006 220.075 157.073 189.986 157.073 144.961V48.6272H126.614ZM109.859 117.471C97.6045 117.471 87.674 107.529 87.674 95.2601C87.674 82.9914 97.6091 73.0493 109.859 73.0493C122.109 73.0493 132.044 82.9914 132.044 95.2601C132.044 107.529 122.109 117.471 109.859 117.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.749 106.676H202.92C194.982 106.676 188.038 112.011 185.985 119.686L178.089 149.195H197.918L205.814 119.686C207.867 112.011 214.815 106.676 222.749 106.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.212 106.676H234.474C226.54 106.676 219.592 112.011 217.539 119.686L209.643 149.195H242.269C250.207 149.195 257.151 143.86 259.203 136.184L267.1 106.676H259.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.192 162.467V91.1407H1003.29C1011.23 91.1407 1018.18 85.8057 1020.23 78.1303L1028.12 48.6174H990.192V0.616211L946.025 42.3011V48.6174L945.537 48.8431C934.452 50.17 925.106 58.0987 922.16 69.105L918.728 81.9404L916.266 91.1407H946.02V162.467C946.02 208.769 966.917 226.925 1028.89 220.079V179.965C1003.57 181.333 990.188 180.979 990.188 162.467H990.192Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1028.29,
    height: 224.259,
    fill: "white",
    transform: "translate(0.600098 0.616211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUVaultLogoWhite);
export default __webpack_public_path__ + "static/media/u-vault-logo-white.2fffba264dd7b79ff1115d1ea8f8f591.svg";
export { ForwardRef as ReactComponent };